import { getAuthHeaders } from "modules/common";
import { createService } from "services/serviceFactory";
import {
    CreateMobileAppRequest,
    EditMobileAppRequest,
    GetMobileAppRequest,
} from "./request";
import { MobileApp, MobileAppPaginatedResponse } from "./response";

const mobileAppService = createService("mobileapps");

async function getMobileApps(data: GetMobileAppRequest, accessToken: string) {
    const authHeaders = getAuthHeaders(accessToken);
    const response = await mobileAppService.get<MobileAppPaginatedResponse>(
        "/mobileapps/v1/mobileapps",
        {
            params: data,
            ...authHeaders,
        }
    );
    return response.data;
}

async function createMobileApp(
    data: CreateMobileAppRequest,
    file: File | null,
    accessToken: string
) {
    const authHeaders = getAuthHeaders(accessToken);
    const formData = new FormData();
    formData.append("mobileAppJson", JSON.stringify(data));
    if (file) {
        formData.append("formFile", file);
    }
    const response = await mobileAppService.post(
        "/mobileapps/v1/mobileapps",
        formData,
        authHeaders
    );
    return response.data;
}

async function editMobileApp(
    data: EditMobileAppRequest,
    file: File | null,
    accessToken: string
) {
    const authHeaders = getAuthHeaders(accessToken);
    const formData = new FormData();
    formData.append("mobileAppJson", JSON.stringify(data));
    if (file) {
        formData.append("formFile", file);
    }
    const response = await mobileAppService.patch<MobileApp>(
        `/mobileapps/v1/mobileapps`,
        formData,
        authHeaders
    );
    return response.data;
}

async function deleteMobileApp(guid: string, accessToken: string) {
    const authHeaders = getAuthHeaders(accessToken);
    const response = await mobileAppService.delete(
        `/mobileapps/v1/mobileapps/${guid}`,
        authHeaders
    );
    return response;
}

export {
    getMobileApps,
    createMobileApp,
    editMobileApp,
    deleteMobileApp,
};
